import { CheckCircleTwoTone, QuestionCircleOutlined, WarningTwoTone } from '@ant-design/icons';
import React from 'react';
import * as libCon from '../community-hats-js-library/Constants.js';
import Title from 'antd/es/typography/Title';
import { Spin } from 'antd';
import { RefStoredValue } from '../hooks/GeneralStoreHooks';
import { RefContextLanguage } from '../providers/LanguageProvider';

const DatabaseStatus = ({ title, status }) => {
  const Symbol = ({ status }) => {
    switch (status) {
      case libCon.LOADING:
        return <Spin />;
      case libCon.OK:
        return <CheckCircleTwoTone twoToneColor="#52c41a" />;
      case libCon.ERROR:
        return <WarningTwoTone twoToneColor="#e91822" />;
      default:
        return <QuestionCircleOutlined />;
    }
  };

  return (
    <div style={{ marginLeft: '10px', marginRight: '10px' }}>
      <Title level={5}>{title}</Title>
      <Symbol status={status} />
    </div>
  );
};

export function LoadingParticipants() {
  const i18n = RefContextLanguage();

  // Participants
  const statusParticipants = RefStoredValue(libCon.STATUS_DATASET_PARTICIPANTS);

  return (
    <div className="verticalSection">
      <DatabaseStatus title={i18n.t('participants')} status={statusParticipants} />
    </div>
  );
}

export function LoadingGoveeActivationCodes() {
  const i18n = RefContextLanguage();

  // Participants
  const statusCodes = RefStoredValue(libCon.STATUS_DATASET_GOVEE_ACTIVATION_CODES);

  return (
    <div className="verticalSection">
      <DatabaseStatus title={i18n.t('activationCodes')} status={statusCodes} />
    </div>
  );
}

export function LoadingActionItemsAndParticipants() {
  const i18n = RefContextLanguage();

  // Participants
  const statusParticipants = RefStoredValue(libCon.STATUS_DATASET_PARTICIPANTS);

  // Received Sensor Files
  const statusActionItems = RefStoredValue(libCon.STATUS_DATASET_ISSUES);

  return (
    <div className="verticalSection">
      <div className="horizontalSection">
        <DatabaseStatus title={i18n.t('participants')} status={statusParticipants} />
        <DatabaseStatus title={i18n.t('actionItems')} status={statusActionItems} />
      </div>
    </div>
  );
}

function LoadingDatasets() {
  const i18n = RefContextLanguage();

  // Participants
  const statusParticipants = RefStoredValue(libCon.STATUS_DATASET_PARTICIPANTS);

  // Houses
  const statusHouses = RefStoredValue(libCon.STATUS_DATASET_HOUSES);

  // Emails
  const statusEmails = RefStoredValue(libCon.STATUS_DATASET_EMAILS);

  // Sensors
  const statusSensors = RefStoredValue(libCon.STATUS_DATASET_SENSORS);

  // Sensor Placement
  const statusSensorPlacement = RefStoredValue(libCon.STATUS_DATASET_SENSOR_HOUSE_PLACEMENT);

  // Wearables
  const statusWearables = RefStoredValue(libCon.STATUS_DATASET_WEARABLES);

  // Wearable Placement
  const statusWearablesPlacement = RefStoredValue(libCon.STATUS_DATASET_WEARABLE_PLACEMENT);

  // Phones
  const statusPhones = RefStoredValue(libCon.STATUS_DATASET_PHONES);

  // Phone Placement
  const statusPhonePlacement = RefStoredValue(libCon.STATUS_DATASET_PHONE_PLACEMENT);

  // Received Sensor Files
  const statusReceivedSensorFiles = RefStoredValue(libCon.STATUS_DATASET_RECEIVED_SENSOR_FILES);

  // Received Sensor Files
  const statusActionItems = RefStoredValue(libCon.STATUS_DATASET_ISSUES);

  // Participant Placements
  const statusParticipantPlacement = RefStoredValue(libCon.STATUS_DATASET_PARTICIPANT_PLACEMENT);

  // Collection Records
  const statusCollectionRecords = RefStoredValue(libCon.STATUS_DATASET_COLLECTION_RECORDS);

  // Coverage Summary
  const statusCoverageSummary = RefStoredValue(libCon.STATUS_DATASET_COVERAGE_SUMMARY);

  // Battery Change Records
  const statusBatteryChangeRecords = RefStoredValue(libCon.STATUS_DATASET_BATTERY_CHANGE_RECORDS);

  return (
    <div className="verticalSection">
      <div className="horizontalSection">
        <DatabaseStatus title={i18n.t('participants')} status={statusParticipants} />
        <DatabaseStatus title={i18n.t('houses')} status={statusHouses} />
        <DatabaseStatus title={i18n.t('sensors')} status={statusSensors} />
        <DatabaseStatus title={i18n.t('sensorPlacement')} status={statusSensorPlacement} />
        <DatabaseStatus title={i18n.t('wearables')} status={statusWearables} />
        <DatabaseStatus title={i18n.t('emails')} status={statusEmails} />
        <DatabaseStatus title={i18n.t('collectionRecords')} status={statusCollectionRecords} />
        <DatabaseStatus title={i18n.t('batteryRecords')} status={statusBatteryChangeRecords} />
      </div>
      <div className="horizontalSection">
        <DatabaseStatus title={i18n.t('wearablesPlacement')} status={statusWearablesPlacement} />
        <DatabaseStatus title={i18n.t('participantPlacementsTitle')} status={statusParticipantPlacement} />
        <DatabaseStatus title={i18n.t('phones')} status={statusPhones} />
        <DatabaseStatus title={i18n.t('phonePlacementTitle')} status={statusPhonePlacement} />
        <DatabaseStatus title={i18n.t('receivedSensorFiles')} status={statusReceivedSensorFiles} />
        <DatabaseStatus title={i18n.t('actionItems')} status={statusActionItems} />
        <DatabaseStatus title={i18n.t('coverageSummary')} status={statusCoverageSummary} />
      </div>
    </div>
  );
}

export default LoadingDatasets;
